import { IOptionMap, IProduct } from '../../../../../../data/api/models';
import * as React from 'react';
import { Field } from 'redux-form';
import { Button } from 'react-bootstrap';
import { isRequired } from '../../../../../../util/validators';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as modalActions } from '../../../../../../services/modal/reducer';
import { IModalActions, IModalState } from '../../../../../../services/modal/model';
import OptionsModal from './Components/OptionsModal';
import { OptionsYesSelectionText } from './Components/OptionsYesSelectionText';

interface ITripOptionsProps {
  options: IOptionMap,
  product: IProduct;
  modal: IModalState,
  actions: {
    modal: IModalActions
  }

  change(field: string, value: any): void;
}

const TripOptions = ({ options, product, change, modal, actions }: ITripOptionsProps) => {

  const openOptionsTextModal = (key: string) => () => {
    actions.modal.openOptionsModal(key)
  }

  const prepData = (key: string) => {
    const data = {
      key,
      // iconActive: require(`../../../../img/${key}_color.svg`),
      // iconInActive: require(`../../../../img/${key}_grey.svg`),
      icon: require(`../../../../img/${key}.svg`),
      popOverText: product.metadata.definitions[`${key}_alt_help`],
      text: product.metadata.definitions[`${key}_alt_dynamic`],
      selectedYesText: null,
      selectedNoText: product.metadata.definitions[`${key}_alt_selected_no`],
      title: product.metadata.definitions[`${key}_alt_title`],
      subTitle: null
    };
    if (key === 'winter_sports') {
      data.title = data.title.replace('{alt_value}', 'Up to £500');
      const yesSelectedWinter = [
        'Up to £500 for winter sports related incidents',
        'Lost, stolen or damaged equipment owned or hired by yourself',
        'Piste closure and delay caused by avalanche',
        'Winter Sports trips are covered up to a maximum of 21 days per policy term'
      ]

      data.selectedYesText = (<OptionsYesSelectionText text={yesSelectedWinter}/>)

      data.selectedNoText = 'IMPORTANT - This policy will not cover claims for medical treatment, cancellation or cutting your trip short if you take part in winter sports activities.'

      data.subTitle = (
        <div className={'option-subtext'}>Check out our winter sports activities list <span
          style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={openOptionsTextModal(key)}>here</span>
        </div>
      )
    }

    if (key === 'cruise_cover') {
      const yesSelectedCruise = [
        'Up to £750 for Cruise related incidents',
        'Missed port departure, cruise interruption and itinerary change',
        'Extend your policy limits to cover you whilst on a cruise',
      ]

      data.selectedYesText = (<OptionsYesSelectionText text={yesSelectedCruise}/>)
      data.selectedNoText = 'IMPORTANT - This policy will not cover claims for medical treatment, cancellation or cutting your trip short if you plan on going on a cruise.'

      data.subTitle = (
        <div className={'option-subtext'}>Click <span
          style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={openOptionsTextModal(key)}>here</span> to
          see
          what we define as a cruise
        </div>
      )
    }
    return data;
  };

  const data = [
    prepData('winter_sports'),
    prepData('cruise_cover'),
  ];

  const SelectButton = (props) => {
    const {
      input,
      data,
    } = props;

    const opt = options[data.key];
    const selection: boolean | undefined = opt === true || opt === false ? opt : undefined;

    const handleClick = (value: boolean) => {
      const optKey = input.name;
      change(optKey, value);
    };

    return (
      <div className={'select-button'}>
        <Button
          className={selection === true ? 'selected' : ''}
          onClick={handleClick.bind(this, true)}
        >
          Yes
        </Button>
        <Button
          className={selection === false ? 'selected' : ''}
          onClick={handleClick.bind(this, false)}
        >
          No
        </Button>
      </div>
    );
  }

  const renderButtons = (data) => {
    return (
      <div>
        <Field
          data={data}
          name={`options.${data.key}`}
          component={SelectButton}
          validate={[isRequired]}
        />
      </div>
    );
  };

  const renderText = (data) => {
    const opt = options[data.key];
    const selection: boolean | undefined = opt === true || opt === false ? opt : undefined;
    if (selection) {
      return <div className={'yes-text'}>{data.selectedYesText}</div>;
    } else if (selection === false) {
      return <div className={'no-text'}>{data.selectedNoText}</div>;
    } else {
      return <></>;
    }
  }

  return (
    <div className={'trip-options'}>

      <div>
        <div className={'cyc--title'} style={{ marginBottom: '10px' }}>
          Winter Sports & Cruise cover:
        </div>
        <div>
          The below cover is required if you plan on taking part in winter sports activities or a cruise. If you do not
          select this cover you will have no cover for your trip, including any medical and trip cancellation costs.
        </div>
      </div>

      {data.map(v => (
        <>
          <div key={v.key} className={'trip-options-container'}>
            <div className={'row'}>
              <img className={'image'} src={v.icon} alt={''}/>
              <div className={'text'}>
                <div className={'title-container'}>
                  <div className={'title'}>{v.title}</div>
                  <div className={'sub-title'}>{v.subTitle}</div>
                </div>
              </div>
            </div>
            {renderButtons(v)}
          </div>
          {renderText(v)}
          <OptionsModal/>
        </>
      ))}
    </div>
  );

};

export default connect(
  (state: IStore) => {
    return {
      modal: state.modal,
    };
  },
  (dispatch) => ({
    actions: {
      modal: bindActionCreators({ ...modalActions }, dispatch),

    },
  }))(TripOptions);
